// @ts-check

import httpClient from "@/config/httpClient";

/**
 * @typedef {Promise<{response: Record<string, unknown>, isError: boolean}>} GenericMutationResponse
 */

/**
 * Generic mutation helper that matches swrMutator return type
 * @param {Object} options
 * @param {"get" | "post" | "put" | "delete" | "patch"} [options.method]
 * @param {string} options.url
 * @param {Object} [options.payload]
 *
 * @returns {GenericMutationResponse}
 */
export async function genericMutation({ method = "get", url, payload }) {
	const { isError, response } = await httpClient[method](url, payload);

	if (isError) {
		return { isError, response };
	}

	return { isError: false, response };
}
